import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum CaulipuffsCopackPOLineItemKeys {
  itemNumber = 'itemNumber', // line item number, not to be entered by user
  itemName = 'itemName', // name of the item, often SKU, Unique ID, refernce ID, etc
  description = 'description', // verbose description of the item (human parseable)
  palletQty = 'palletQty', // quantity of pallets for each item
  caseQty = 'caseQty', // quantity of the cases for each item for order
  price = 'price', // price
  lineTotal = 'lineTotal', // total cost per (price * caseQty), not to be entered by user
}

export const caulipuffsCopackPurchaseOrderFileDataSchema = yup.object().shape({
  buyer: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  purchaseOrderNumber: yup.string().nullable().optional(),
  externalReferenceNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  shipDate: yup.string().nullable().optional(),
  appointmentTime: yup.string().nullable().optional(),
  destination: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        itemNumber: yup.number().nullable().optional(),
        itemName: yup.string().nullable().optional(),
        description: yup.string().nullable().optional(),
        palletQty: yup.string().nullable().optional(),
        caseQty: yup.string().nullable().optional(),
        price: yup.string().nullable().optional(),
        lineTotal: yup.string().nullable().optional(),
      }),
    )
    .required(),
  agreement: yup.string().nullable().optional(),
  instructions: yup.string().nullable().optional(),
})

export type CaulipuffsCopackPurchaseOrderFileData = yup.InferType<
  typeof caulipuffsCopackPurchaseOrderFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<CaulipuffsCopackPurchaseOrderFileData>

export const caulipuffsCopackPurchaseOrderFileMappings: RequiredFileData = {
  buyer: {
    companyName: 'abae07e6-954e-44d6-8a61-40f46283ff91',
    address: 'f25c9de1-644b-46b2-a3fa-1cb5eb6c5ece',
    contactName: 'dc032768-36f8-4b3f-b4b7-f0f416fe144e',
    phoneNumber: 'b8dbbb3e-affb-40b5-b25e-273ad9f457ab',
    emailAddress: '05a7d4e7-d188-4375-aed7-38a01bf2adb2',
  },
  purchaseOrderNumber: '07030ec4-b6c1-4bec-b323-60c9f981799f',
  externalReferenceNumber: 'c91dad6f-a10d-4ae3-a89b-fa17a77e70eb',
  dateIssued: '2b0a69ad-9aae-4a46-a36b-0a3e5e87f6cd',
  shipDate: '05477c6f-8b9d-438d-8646-5191bf6a15ef',
  appointmentTime: 'dc069edc-7292-480b-b9d0-aee7d3c49e4e',
  destination: {
    companyName: 'd3f92a0e-271f-438d-a0b7-4c467404165e',
    address: 'd0ec1f3e-faeb-4522-80f2-e42293b5bb09',
    contactName: '343bfdf2-d960-4ba1-b172-50dceae2595a',
    phoneNumber: 'd01d99d0-27d2-4103-ab34-56c3951f0064',
    emailAddress: 'e9d3b3bd-2060-4903-84ae-ecd8a773f37c',
  },
  items: [
    {
      itemNumber: null,
      itemName: '1a9a878b-06bc-4c61-8742-710c14c475f6',
      description: '31484a29-7a27-40bf-951c-2ccbe5d70b2b',
      palletQty: '2ec28d64-35a7-40d3-9f4e-c374c57c1ed1',
      caseQty: '28beac14-ccb4-4db5-8b7f-2d43a331ef27',
      price: '3d23bb72-5b2f-44fd-b6a7-ba7b957af679',
      lineTotal: null,
    },
  ],
  agreement: 'abf5c3c0-5dd8-4a1f-83b8-e57bc0109eb3',
  instructions: 'd5f43f0a-ca95-4961-a511-f0800b25a1b5',
}
